module.exports = __webpack_public_path__ + "static/media/screenshot(17).3b63a0fe.jpg";